import styled, { css, DefaultTheme } from 'styled-components';
import { StylesConfig } from 'react-select';
import CreatableSelect, { CreatableProps } from 'react-select/creatable';
import theme from '../../theme';

const StyledSelect = styled(CreatableSelect)<{ isDisabled?: boolean }>`
  input[type='text'] {
    height: 30px !important;
  }
  ${({ isDisabled }) =>
    isDisabled &&
    css`
      opacity: 0.5;
    `}
`;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type Props = CreatableProps<any, any, any> & Partial<{ theme: DefaultTheme }>;

export const Dropdown = (props: Props) => (
  <StyledSelect {...props} styles={selectCustomStyles} />
);

const selectCustomStyles: StylesConfig = {
  menu: (provided) => ({
    ...provided,
    transition: 'all 0.3s ease-in-out',
    backgroundColor: theme.colors.inputBackground,
    borderColor: theme.colors.bgActive,
    borderStyle: 'solid',
    borderWidth: '1px',
    borderRadius: '8px',
  }),
  menuPortal: (provided) => ({
    ...provided,
    zIndex: 3,
  }),
  container: (provided) => ({
    ...provided,
    margin: 0,
    marginTop: '8px',
    paddingBottom: '12px',
  }),

  control: (provided, { isFocused }: { isFocused: boolean }) => ({
    ...provided,
    transition: 'all 0.3s ease-in-out',
    backgroundColor: theme.colors.inputBackground,
    borderColor: isFocused
      ? theme.colors.inputBorderActive
      : theme.colors.bgActive,
    padding: '4.5px 12px',
    margin: 0,
    height: '100%',
    borderRadius: '8px',
    boxShadow: '0 !important',
    outline: 'none',
    '&:hover': {
      borderColor: theme.colors.inputBorderActive,
    },
    cursor: 'pointer',
  }),

  option: (
    provided,
    { isSelected, isFocused }: { isSelected: boolean; isFocused: boolean }
  ) => ({
    ...provided,
    backgroundColor:
      isSelected || isFocused ? theme.colors.fieldBackground : 'transparent',
    color:
      isSelected || isFocused
        ? theme.colors.textPrimary
        : theme.colors.textRegular,
    cursor: isSelected ? 'not-allowed' : 'default',
    '&:active': {
      color: theme.colors.textPrimary,
      backgroundColor: theme.colors.fieldBackground,
    },
  }),

  singleValue: (provided) => ({
    ...provided,
    color: theme.colors.inputTextActive,
  }),
  input: (provided) => ({
    ...provided,
    color: theme.colors.inputTextActive,
  }),
  placeholder: (provided) => ({
    ...provided,
    color: theme.colors.inputTextPlaceholder,
  }),
};
